export const styles = {
	handshake: {
		'@media (max-width:380px)': {
			transform: 'scale(0.75)',
		},
	},
};
